import React from "react";
import Slider from "react-slick";
import treatment1 from '../Components/img/treament1.jpg';
import treatment2 from '../Components/img/treament2.jpg';
import treatment3 from '../Components/img/treament3.jpg';
import treatment4 from '../Components/img/treament4.jpg';
import treatment5 from '../Components/img/treament5.jpg';
import treatment6 from '../Components/img/treament6.jpg';
import treatment7 from '../Components/img/treament8.jpg';
const SuccessStories = () => {
  const settings = {
    dots: true, // Show dots below slider
    infinite: true, // Infinite loop sliding
    speed: 3000, // Transition speed
    slidesToShow: 3, // Number of slides visible
    slidesToScroll: 1, // Number of slides to scroll
    autoplay: true, // Enable auto sliding
    autoplaySpeed: 2000, // Speed of auto sliding
    
    responsive: [
      {
        breakpoint: 1024, // For tablets and smaller screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // For mobile devices
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const stories = [
    {
      id: 1,
      name: "John Doe",
      role: "Patient",
      title: "Cardiac Treatment",
      content: "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      image: treatment1,
    },
    {
      id: 2,
      name: "Jane Smith",
      role: "Patient",
      title: "Orthopedic Treatment",
      content: "Thank you to the entire team for your exceptional service. You made my recovery easier and quicker than I expected.",
      image: treatment2,
    },
    {
      id: 3,
      name: "Sarah Williams",
      role: "Patient",
      title: "Neurology Treatment",
      content: "A fantastic hospital with highly skilled professionals who genuinely care for your health and well-being.",
      image: treatment3,
    },
    {
      id: 4,
      name: "John Doe",
      role: "Patient",
      title: "Cardiac Treatment",
      content: "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      image: treatment4,
    },
    {
      id: 5,
      name: "John Doe",
      role: "Patient",
      title: "Cardiac Treatment",
      content: "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      image: treatment5,
    },
    {
      id: 6,
      name: "John Doe",
      role: "Patient",
      title: "Cardiac Treatment",
      content: "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      image: treatment6,
    },
    {
      id: 7,
      name: "John Doe",
      role: "Patient",
      title: "Cardiac Treatment",
      content: "The staff at the hospital was incredible. They provided the best care during my stay. I highly recommend their services.",
      image: treatment7,
    },
  
  
  ];

  return (
    
    <div className="py-5 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center mb-3">
            <h2 className="text-dark">Success Stories</h2>
            <p className="text-muted">What our patients say about us</p>
          </div>
          <Slider {...settings}>
          {stories.map((story) => (
            <div key={story.id} className="col-lg-4 mb-5  px-3 col-md-12  ">
              <div className="card shadow border-0 p-4">
                <img src={story.image} alt={story.title} className="img-fluid rounded-circle mb-4" />
                <h4 className="text-primary">{story.name}</h4>
                <p className="text-muted">{story.role}</p>
                <h5 className="text-primary">{story.title}</h5>
                <p className="text-muted">{story.content}</p>
              </div>
            </div>
            
          ))}
          </Slider>
        </div>
      </div>
    </div>
  
  );
};

export default SuccessStories;
